module.exports = __webpack_public_path__ + "images/application/icon-external-link-c8fffc81.svg";